module.exports = __webpack_public_path__ + "static/media/usim_logo.15f7dac4.png";